import { buttonSX } from '@/components/blocks/DpLibrary/DpButtonPhone/style/main';
import { Button, useMediaQuery, useTheme } from '@mui/material';
import PhoneIcon from '@mui/icons-material/Phone';
export const DpButtonPhone = ({ label, phoneNumber }: { label: string; phoneNumber: string }) => {
	const theme = useTheme();
	const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

	const handleClick = () => {
		if (isMobile) {
			window.open(`tel:${phoneNumber}`, '_self');
		}
	};

	return (
		<Button
			component="a"
			href={isMobile ? undefined : `tel:${phoneNumber}`}
			type="submit"
			variant="contained"
			sx={buttonSX}
			startIcon={<PhoneIcon sx={{ fontSize: 'var(--font-size-xl) !important' }} />}
			onClick={handleClick}
		>
			{label}
		</Button>
	);
};
